module.exports = __webpack_public_path__ + "static/media/CHI 2018 Papers.044d6f4b.csv";